/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class EIAFuelGroup extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "EIAFuelGroup";
}

const servicePlugin = makeServicePlugin({
  Model: EIAFuelGroup,
  service: feathersClient.service("data-services/eia/fuel-groups"),
  idField: "Series ID",
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
